// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    fullName: null,
    email: null,
    isAuthenticated: false,
  });

  useEffect(() => {
    // Leer las cookies al cargar la aplicación
    const fullName = Cookies.get('fullName');
    const email = Cookies.get('email');

    if (fullName && email) {
      setAuth({
        fullName,
        email,
        isAuthenticated: true,
      });
    }
  }, []);

  const login = (fullName, email) => {
    Cookies.set('fullName', fullName, { sameSite: 'lax' });
    Cookies.set('email', email, { sameSite: 'lax' });
    setAuth({
      fullName,
      email,
      isAuthenticated: true,
    });
  };

  const logout = () => {
    Cookies.remove('fullName');
    Cookies.remove('email');
    setAuth({
      fullName: null,
      email: null,
      isAuthenticated: false,
    });
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
